/* vpb-analytics.js — first-party funnel telemetry for lushlobster.com.
 *
 * Captures: session (30-min inactivity window), landing attribution
 * (utm_* + gclid, first non-empty wins per session), page views typed by
 * template, checkout starts, and the add-something-sweet → reminders
 * pass-through. Also stamps the session id + attribution onto the cart as
 * attributes so every ORDER joins back to its session/campaign in Shopify.
 *
 * Exposes window.vpbTrack(event, props) for the card-customiser bundle
 * (editor_enter/complete, drawer + gift-rail events). Fire-and-forget:
 * batched, sendBeacon on pagehide, text/plain bodies (no CORS preflight),
 * and every call is try/caught — telemetry can never break the storefront.
 * No PII is collected.
 *
 * ⚠ DO NOT REMOVE from the theme — /metrics + the web_events pipeline
 * depend on this file and the include at the bottom of layout/theme.liquid.
 */
(function () {
  var EP = 'https://va.lushlobster.com/api/track';
  var now = Date.now();

  // ── session (GA-style: new after 30 min inactivity) ──
  var sid = null, last = 0;
  try {
    sid = localStorage.getItem('vpb_sid');
    last = Number(localStorage.getItem('vpb_last')) || 0;
  } catch (e) { /* private mode */ }
  var fresh = !sid || (now - last) > 30 * 60 * 1000;
  if (fresh) sid = now.toString(36) + Math.random().toString(36).slice(2, 10);
  try {
    localStorage.setItem('vpb_sid', sid);
    localStorage.setItem('vpb_last', String(now));
  } catch (e) { /* no-op */ }

  // ── attribution: query params win; else keep the session's stored one ──
  var qs = new URLSearchParams(location.search);
  var attr = null;
  try { attr = JSON.parse(localStorage.getItem('vpb_attr') || 'null'); } catch (e) { /* no-op */ }
  if (fresh) attr = null; // new session starts attribution afresh
  var qa = {
    s: qs.get('utm_source'), m: qs.get('utm_medium'), c: qs.get('utm_campaign'),
    t: qs.get('utm_term'), n: qs.get('utm_content'), g: qs.get('gclid'),
    f: qs.get('fbclid')
  };
  if (qa.f) qa.ft = Date.now(); // fbc click-id format needs the capture time
  if (qa.s || qa.g || qa.c || qa.f) {
    attr = qa;
    try { localStorage.setItem('vpb_attr', JSON.stringify(attr)); } catch (e) { /* no-op */ }
  }
  attr = attr || {};

  var device = /Mobi|Android|iPhone|iPad/.test(navigator.userAgent) ? 'mobile' : 'desktop';

  function pageType(p) {
    p = p || location.pathname;
    if (p === '/' || p === '') return 'home';
    // PDPs opened from a grid live at /collections/<handle>/products/<handle>,
    // so a bare startsWith('/products/') mislabelled ~8% of card views as
    // "collection" (fixed 27 Aug 2026).
    if (p.indexOf('/products/') !== -1) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/add-something-sweet') === 0) return 'ass';
    if (p.indexOf('/pages/gifts') === 0) return 'gifts';
    if (p.indexOf('/pages/reminders') === 0) return 'reminders';
    if (p.indexOf('/cart') === 0) return 'cart';
    return 'other';
  }

  // ── batched transport ──
  var q = [], timer = null;
  function flush(useBeacon) {
    if (!q.length) return;
    var body = JSON.stringify({ events: q.splice(0, q.length) });
    try {
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(EP, new Blob([body], { type: 'text/plain' }));
        return;
      }
      fetch(EP, { method: 'POST', body: body, keepalive: true });
    } catch (e) { /* never break the page */ }
  }
  function track(ev, props) {
    try {
      q.push({
        sid: sid, event: ev, path: location.pathname, page_type: pageType(),
        device: device, referrer: document.referrer || null,
        utm_source: attr.s || null, utm_medium: attr.m || null,
        utm_campaign: attr.c || null, utm_term: attr.t || null,
        utm_content: attr.n || null, gclid: attr.g || null,
        props: props || {}, ts: new Date().toISOString()
      });
      localStorage.setItem('vpb_last', String(Date.now()));
      clearTimeout(timer);
      timer = setTimeout(function () { flush(false); }, 1200);
    } catch (e) { /* no-op */ }
  }
  window.vpbTrack = track;
  // Manual beacon-flush for callers whose events fire during tab-hide AFTER
  // our own hidden/pagehide flush has already run (listener order = register
  // order, and the customiser bundle registers later than this script). The
  // editor's abandon telemetry calls this so the event isn't stranded in the
  // queue past the beacon window.
  window.vpbFlush = function () { flush(true); };

  if (fresh) track('session_start', { landing: (location.pathname + location.search).slice(0, 180) });
  track('page_view');

  // ── checkout starts + interstitial proceed clicks (capture phase) ──
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('a[href*="/checkout"], button[name="checkout"]')) {
      track('checkout_start', { from: pageType() }); flush(true);
    } else if (t.closest('a[href*="/pages/reminders"]') && pageType() === 'ass') {
      track('ass_proceed', {}); flush(true);
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/checkout/.test(f.getAttribute && (f.getAttribute('action') || ''))) {
      track('checkout_start', { from: pageType() }); flush(true);
    }
  }, true);
  addEventListener('pagehide', function () { flush(true); });
  // pagehide never fires on a plain tab-switch/app-switch (common on mobile);
  // visibilitychange→hidden is the last reliable moment to beacon there.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush(true);
  });

  // ── Klaviyo onsite forms → bundle-popup funnel ──
  // The "BUNDLES POP UP" form (id R4XwaL) advertises the bundle wizard; its
  // "Customize Now" CTA redirects to /pages/build-a-bundle. Klaviyo.js emits
  // window 'klaviyoForms' events for every onsite form — we map open →
  // bundle_popup_view and the CTA redirect → bundle_popup_cta, this form only,
  // so email-capture popups never pollute the bundle funnel.
  var BUNDLE_FORM_ID = 'R4XwaL';
  addEventListener('klaviyoForms', function (e) {
    try {
      var d = (e && e.detail) || {};
      if (String(d.formId) !== BUNDLE_FORM_ID) return;
      if (d.type === 'open' || d.type === 'embedOpen') {
        track('bundle_popup_view', { formId: d.formId });
      } else if (d.type === 'redirectedToUrl') {
        track('bundle_popup_cta', { formId: d.formId });
        flush(true); // page is about to navigate — don't lose the click
      }
    } catch (err) { /* no-op */ }
  });

  // ── stamp session + attribution onto the cart (joins ORDERS to sessions).
  //    Underscore-prefixed attributes surface in admin/API, not to customers. ──
  function stamp() {
    try {
      if (localStorage.getItem('vpb_stamped') === sid) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.item_count) return;
          if (c.attributes && c.attributes._vpb_sid === sid) {
            try { localStorage.setItem('vpb_stamped', sid); } catch (e) { /* no-op */ }
            return;
          }
          var attrs = { _vpb_sid: sid };
          if (attr.g) attrs._vpb_gclid = attr.g;
          if (attr.f) {
            attrs._vpb_fbclid = attr.f;
            if (attr.ft) attrs._vpb_fbclid_ts = String(attr.ft);
          }
          // _fbp exists only when the Meta pixel ran (consent given) — free
          // extra match quality for the server-side CAPI event.
          var fbp = (document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/) || [])[1];
          if (fbp) attrs._vpb_fbp = fbp;
          if (attr.s) attrs._vpb_utm_source = attr.s;
          if (attr.c) attrs._vpb_utm_campaign = attr.c;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).then(function () {
            try { localStorage.setItem('vpb_stamped', sid); } catch (e) { /* no-op */ }
          });
        });
    } catch (e) { /* no-op */ }
  }
  stamp();
  document.addEventListener('cart:refresh', stamp);
  setTimeout(stamp, 8000); // catch first add-to-cart shortly after landing

  // ── Field INP sample (2026-07-29 INP campaign) ──
  // Real interaction latencies via the Event Timing API; report the worst
  // per page on pagehide. Gives a SAME-DAY first-party INP scoreboard in
  // web_events instead of waiting on the 28-day CrUX window. interactionId
  // filters to real discrete interactions (taps/keys), like INP proper.
  (function () {
    var worst = 0, n = 0;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.interactionId) { n++; if (e.duration > worst) worst = e.duration; }
        });
      }).observe({ type: 'event', durationThreshold: 40, buffered: true });
    } catch (e) { return; /* older browsers: no sample, no harm */ }
    addEventListener('pagehide', function () {
      if (n > 0) { track('inp_sample', { v: Math.round(worst), n: n, pt: pageType() }); flush(true); }
    });
  })();
})();
